import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { urlValidator } from '@tablesready/common-ui';
import { Webhook } from '@shared/webhook/models';
import { WEBHOOK_EVENTS_LIST } from '@shared/webhook/constants';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-add-edit-webhook',
  templateUrl: './add-edit-webhook.component.html',
})
export class AddEditWebhookComponent implements OnInit {
  @Input() webhook?: Omit<Webhook, '_id' | 'restaurant'>;
  @Input() id?: string;
  icon = AppIcon;
  form: UntypedFormGroup;
  title: string;
  events = WEBHOOK_EVENTS_LIST;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly modelController: FrontendModalService,
  ) {
  }

  ngOnInit(): void {
    this.title = this.id ? 'Edit webhook' : 'Add webhook';
    this.form = this.formBuilder.group({
      url: [this.webhook?.url || '', [Validators.required, urlValidator]],
      description: [this.webhook?.description || ''],
      events: [this.webhook?.events || [], [Validators.required]],
    });
  }

  cancel(): void {
    this.modelController.dismiss();
  }

  submit(): void {
    this.modelController.dismiss({
      data: this.form.getRawValue(),
      id: this.id || undefined,
    });
  }
}
